import React, { Component, ReactNode } from 'react'
import { SketchPicker, ColorResult, ChromePicker } from 'react-color'

import './ColorPickerButton.less'

interface IProps {
  color: string
  onChange: (color: string) => void
  simplified?: boolean
}

interface IState {
  displayColorPicker: boolean
}

// TODO refactor to FC
export default class ColorPickerButton extends Component<IProps, IState> {
  state = {
    displayColorPicker: false,
    color: null
  }

  handleClick = (): void => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = (): void => {
    this.setState({ displayColorPicker: false })
  }

  handleChange = (color: ColorResult): void => {
    this.props.onChange(color.hex)
  }

  render(): ReactNode {
    const { displayColorPicker } = this.state
    const { color } = this.props

    return (
      <div className="ColorPickerButton">
        <div
          className="swatch"
          style={{ background: color }}
          onClick={this.handleClick}
        />
        {displayColorPicker ? this.renderColorPicker() : null}
      </div>
    )
  }

  private renderColorPicker(): ReactNode {
    const { color, simplified } = this.props

    if (simplified) {
      return (
        <div className="color-popover">
          <div className="close-cover" onClick={this.handleClose} />
          <ChromePicker
            color={color}
            disableAlpha={true}
            onChange={this.handleChange}
          />
        </div>
      )
    } else {
      const presetColorsPalette = [
        '#E02020',
        '#FA6400',
        '#F7B500',
        '#FFCB20',
        '#6DD400',
        '#00BB77',
        '#32C5FF',
        '#0091FF',
        '#005A9F',
        '#6236FF',
        '#B620E0',
        '#111111',
        '#6D7278',
        '#B1BFC5',
        '#DDDDDD',
        '#FFFFFF'
      ]
      return (
        <div className="color-popover">
          <div className="close-cover" onClick={this.handleClose} />
          <SketchPicker
            color={color}
            disableAlpha={false}
            presetColors={presetColorsPalette}
            onChange={this.handleChange}
          />
        </div>
      )
    }
  }
}
